var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"down-banner-container"},[_c('img',{staticStyle:{"width":"100%","opacity":".3"},attrs:{"src":_vm.item.thumb}})])}
var staticRenderFns = []

export { render, staticRenderFns }